export default {
  SUPER_ADMIN: 'super admin',
  AGENT: 'agent',
  SUPERVISOR: 'supervisor',
  MANAGER: 'manager',
  API: 'api'
}
